import { render, staticRenderFns } from "./HotSpecials.vue?vue&type=template&id=989dc726&scoped=true&"
import script from "./HotSpecials.vue?vue&type=script&lang=js&"
export * from "./HotSpecials.vue?vue&type=script&lang=js&"
import style0 from "./HotSpecials.vue?vue&type=style&index=0&id=989dc726&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989dc726",
  null
  
)

export default component.exports